// extracted by mini-css-extract-plugin
export default {"categoryGroup":"xRWQu6_x9g5hCEQbVyZ_","problemItem":"q8dAyCspHejTXP7zfa8c"};